<ion-header mode="ios">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home" text=""></ion-back-button>
    </ion-buttons>
    <span class="custom-title">{{'wallet' | language: 'Wallet'}}</span>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-card class="wallet-card">
    <ion-card-header>
      <ion-card-title class="ion-text-center">Wallet Balance</ion-card-title>
    </ion-card-header>

    <ion-card-content>
      <ion-grid>
        <ion-row>
          <ion-col size="6" class="ion-text-left">
            <ion-label color="medium">Total Balance</ion-label>
            <h2 *ngIf="walletBalance?.data">
              ₹{{ walletBalance.data.totalBalance | number:'1.2-2' }}
            </h2>
          </ion-col>
          <ion-col size="6" class="ion-text-right">
            <ion-label color="medium">Available Balance</ion-label>
            <h2 color="success" *ngIf="walletBalance?.data">
              ₹{{ walletBalance.data.availableBalance | number:'1.2-2' }}
            </h2>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-card-content>
  </ion-card>

  <ion-button expand="block" color="primary" (click)="addmoney()">
    {{'addmoneytowallet' |language: 'Add money to wallet'}}
  </ion-button>
  <ion-button expand="block" color="primary" (click)="onWithdraw()">
    {{'withdraw' |language: 'Withdraw'}}
  </ion-button>
</ion-content>